import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';

import { PageContent } from 'components/page';
import { SVGButton } from 'components/widgets/buttons';
import { ShortDate } from 'components/widgets/dates';
import { Table } from 'components/content-containers/tables';
import SVG from 'components/widgets/icons/svg';
import Watch from 'services/data/watch';

import * as actions from '../store/actions';

export default function CompanyWatches({ id }) {
  const { data: company } = actions.useCompany(id);
  const { data: watches, setQueryData } = actions.useCompanyWatches(id);

  if (!company) return null;

  const archiveWatch = watch => {
    const updatedWatches = _.reject(watches, { id: watch.id });

    return Watch.update({ id: watch.id, status: 'Archived' })
      .then(() => setQueryData(updatedWatches));
  };

  return (
    <PageContent>
      <div>
        <Link to={`/companies/${company.id}/watches/add`} className="full-page-add-link offset-page-padding btn-success">
          <div>
            <SVG src="svg/add.svg" className="add mr-2" />
            <span>New Watch</span>
          </div>
          <SVG src="svg/growth.svg" />
        </Link>
        <Table>
          <thead>
            <tr>
              <th className="collapse-width">Date</th>
              <th>Notes</th>
              <th className="collapse-width text-right"></th>
            </tr>
          </thead>
          <tbody>
            {_.map(watches, (watch) =>
              <tr key={watch.id}>
                <td className="collapse-width"><ShortDate date={watch.date} /></td>
                <td>{watch.notes}</td>
                <td className="text-right no-padding options-cell">
                  <Link to={`/companies/${company.id}/watches/${watch.id}/edit`}>
                    <SVGButton src="svg/edit.svg" title="Edit Watch" />
                  </Link>

                  <SVGButton src="svg/archived.svg" title="Close Watch" onClick={() => archiveWatch(watch)} />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </PageContent>
  );
}
